export default "__VITE_ASSET__Dbpj3i2e__";